module.exports = __webpack_public_path__ + "img/icon_xiazai_gongsi@3x.f79bb30f.png";